import { ENVIRONMENTS } from "@bronte/viewer-api/src/main";
import {
  getDevShellExpressResolvedTier,
  getEnvFromDevShellExpressTier,
  getURLParams,
} from "./utils";

function resolveEnv(): ENVIRONMENTS {
  const tier = getDevShellExpressResolvedTier(window.location.hostname);
  if (tier !== null) {
    return getEnvFromDevShellExpressTier(tier);
  }
  return getURLParams().env as ENVIRONMENTS;
}

export function getPaperApiBaseUrl(): string {
  switch (resolveEnv()) {
    case ENVIRONMENTS.QA:
      return "https://paperapi-qa.stg-openclass.com";
    case ENVIRONMENTS.PPE:
      return "https://paperapiperf.stg-openclass.com";
    case ENVIRONMENTS.PROD:
      return "https://paperapi.openclass.com";
    default:
      return "https://paperapi.stg-openclass.com";
  }
}

export function getContentServiceBaseUrl(): string {
  switch (resolveEnv()) {
    case ENVIRONMENTS.QA:
      return "https://content-service-qa.stg-prsn.com";
    case ENVIRONMENTS.PPE:
      return "https://content-service-perf.stg-prsn.com";
    case ENVIRONMENTS.PROD:
      return "https://content-service.prd-prsn.com";
    default:
      return "https://content-service.stg-prsn.com";
  }
}

/** CSG glossary `source`; pairs with the host from `getContentServiceBaseUrl()`. */
export function getGlossarySource(): string {
  switch (resolveEnv()) {
    case ENVIRONMENTS.QA:
      return "ISE-QA";
    case ENVIRONMENTS.PPE:
      return "ISE-PERF";
    case ENVIRONMENTS.PROD:
      return "ISE-PROD";
    default:
      return "ISE-STAGE";
  }
}

export function getSearchUserId(): string {
  return resolveEnv() === ENVIRONMENTS.PROD
    ? "ffffffff5f298e8f52faff01da0d391a"
    : "ffffffff5eb5bcb75c771e0131a9efc0";
}
